import LoginForm from "./LoginForm";

const LoginFormContainer = () => {
  return <LoginForm />;
};

export default LoginFormContainer;
